import { api } from '@/lib/api';
import { build_params } from '@/lib/list-query';
import type { SortState } from '@/hooks/use-url-state';
import type {
  AdminReview,
  AdminReviewFilters,
  AdminReviewListResponse,
  ReviewCounts,
} from './types';

/**
 * The list, with whatever filters and sort are set.
 *
 * Through `build_params` rather than a hand-written if-chain: the old version enumerated
 * seven filters by hand, so a filter added to the type but forgotten here would look alive
 * on screen while sending nothing.
 */
export async function fetch_review_list(
  filters: AdminReviewFilters,
  sort?: SortState,
): Promise<AdminReviewListResponse> {
  const res = await api.get<AdminReviewListResponse>('/admin/reviews', {
    params: build_params(filters as Record<string, never>, sort),
  });
  return res.data;
}

/** The tiles. Describes the whole set, so it deliberately ignores the page's filters. */
export async function fetch_review_counts(): Promise<ReviewCounts> {
  const res = await api.get<ReviewCounts>('/admin/reviews/counts');
  return res.data;
}

export async function hide_review(id: string): Promise<AdminReview> {
  const res = await api.post<AdminReview>(`/admin/reviews/${id}/hide`);
  return res.data;
}

export async function unhide_review(id: string): Promise<AdminReview> {
  const res = await api.post<AdminReview>(`/admin/reviews/${id}/unhide`);
  return res.data;
}
